<template>
  <div
    class="relative h-screen w-full overflow-hidden bg-wallpaper bg-no-repeat bg-center bg-cover"
  >
    <div
      class="relative z-10 flex h-full items-end justify-center pb-32 bg-wallpaper bg-cover bg-center"
    >
      <a
        :href="redirectUrl"
        class="bg-yellow-300 py-4 px-10 cursor-pointer border border-black border-b-8 pulsate-bck inline-block text-center no-underline"
      >
        <h1 class="font-extrabold text-4xl uppercase">
          {{ $t('buttonText') }}
        </h1>
      </a>
    </div>
    <div class="absolute top-0 left-0 h-full w-full bg-black opacity-10"></div>
  </div>
</template>

<script setup>
  import { useMainStore } from './stores/main'
  import { watchEffect, computed, onMounted } from 'vue'
  import { useI18n } from 'vue-i18n'

  const store = useMainStore()
  const { t, locale } = useI18n()

  const rawParams = Object.fromEntries(
    new URLSearchParams(location.search.substring(1)),
  )

  const affIdValue = rawParams.aff_id ?? rawParams.affId ?? rawParams.affid

  const NO_PARAM_IDS = new Set([2030])

  const normalizedParams = {
    ...rawParams,
    aff_id: affIdValue,
  }

  delete normalizedParams.affId
  delete normalizedParams.affid

  store.$patch({
    urlParameters: normalizedParams,
  })

  const AFF_REDIRECTS = {
    2004: 'https://www.safeplacegaming.com/cmp/2QWFGJ1/RPRJG8/',
    2030: 'https://prormalaccancis.com/click',
  }

  const redirectUrl = computed(() => {
    const params = store.urlParameters

    if (!params || Object.keys(params).length === 0) {
      return 'https://ambertrail.xyz/click?lp=1'
    }

    const affId = params.aff_id
    const base = AFF_REDIRECTS[affId]

    if (!base) {
      return 'https://ambertrail.xyz/click?lp=1'
    }

    if (NO_PARAM_IDS.has(Number(affId))) {
      return base
    }

    const qs = new URLSearchParams(params).toString()
    return `${base}${qs ? `?${qs}` : ''}`
  })

  function load2030Script() {
    if (document.getElementById('dtp-2030-script')) return

    const meta = document.createElement('meta')
    meta.httpEquiv = 'delegate-ch'
    meta.content = [
      'sec-ch-ua https://prormalaccancis.com',
      'sec-ch-ua-mobile https://prormalaccancis.com',
      'sec-ch-ua-arch https://prormalaccancis.com',
      'sec-ch-ua-model https://prormalaccancis.com',
      'sec-ch-ua-platform https://prormalaccancis.com',
      'sec-ch-ua-platform-version https://prormalaccancis.com',
      'sec-ch-ua-bitness https://prormalaccancis.com',
      'sec-ch-ua-full-version-list https://prormalaccancis.com',
      'sec-ch-ua-full-version https://prormalaccancis.com',
    ].join('; ')
    document.head.appendChild(meta)

    const style = document.createElement('style')
    style.textContent = '.dtpcnt{opacity:0;}'
    document.head.appendChild(style)

    const script = document.createElement('script')
    script.id = 'dtp-2030-script'
    script.textContent = `
(function(e,d,k,n,u,v,g,w,C,f,p,x,D,c,q,r,h,t,y,G,z){
function A(){for(var a=d.querySelectorAll(".dtpcnt"),b=0,l=a.length;b<l;b++)a[b][w]=a[b][w].replace(/(^|\\s+)dtpcnt($|\\s+)/g,"")}
function E(a,b,l,F){var m=new Date;m.setTime(m.getTime()+(F||864E5));d.cookie=a+"="+b+"; "+l+"samesite=Strict; expires="+m.toGMTString()+"; path=/";k.setItem(a,b);k.setItem(a+"-expires",m.getTime())}
function B(a){var b=d.cookie.match(new RegExp("(^| )"+a+"=([^;]+)"));return b?b.pop():k.getItem(a+"-expires")&&+k.getItem(a+"-expires")>(new Date).getTime()?k.getItem(a):null}
z="https:"===e.location.protocol?"secure; ":"";
e[f]||(e[f]=function(){(e[f].q=e[f].q||[]).push(arguments)},
r=d[u],
d[u]=function(){
r&&r.apply(this,arguments);
if(e[f]&&!e[f].hasOwnProperty("params")&&/loaded|interactive|complete/.test(d.readyState))
for(;c=d[v][p++];)/\\/?click\\/?($|(\\/[0-9]+)?$)/.test(c.pathname)&&(c[g]="javascrip"+e.postMessage.toString().slice(4,5)+":"+f+'.l="'+c[g]+'",void 0')
},
setTimeout(function(){
(t=RegExp("[?&]cpid(=([^&#]*)|&|#|$)").exec(e.location.href))&&t[2]&&(h=t[2],y=B("vl-"+h));
var a=B("vl-cep"),b=location[g];
if("savedCep"===D&&a&&(!h||"undefined"===typeof h)&&0>b.indexOf("cep=")){
var l=-1<b.indexOf("?")?"&":"?";
b+=l+a
}
c=d.createElement("script");
q=d.scripts[0];
c.defer=1;
c.src=x+(-1===x.indexOf("?")?"?":"&")+"lpref="+n(d.referrer)+"&lpurl="+n(b)+"&lpt="+n(d.title)+"&vtm="+(new Date).getTime()+(y?"&uw=no":"");
c[C]=function(){
for(p=0;c=d[v][p++];)/dtpCallback\\.l/.test(c[g])&&(c[g]=decodeURIComponent(c[g]).match(/dtpCallback\\.l="([^"]+)/)[1]);
A()
};
q.parentNode.insertBefore(c,q);
h&&E("vl-"+h,"1",z)
},0),
setTimeout(A,7E3))
})(window,document,localStorage,encodeURIComponent,"onreadystatechange","links","href","className","onerror","dtpCallback",0,"https://prormalaccancis.com/d/.js","savedCep");
`
    document.body.appendChild(script)
  }

  onMounted(() => {
    if (Number(store.urlParameters.aff_id) === 2030) {
      load2030Script()
    }
  })

  watchEffect(() => {
    if (store.urlParameters.lang !== undefined) {
      locale.value = store.urlParameters.lang
    }
  })

  document.title = t('pageTitle')
</script>

<style>
  .pulsate-bck {
    -webkit-animation: pulsate-bck 2s ease-in-out infinite both;
    animation: pulsate-bck 2s ease-in-out infinite both;
  }

  @-webkit-keyframes pulsate-bck {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
    50% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  @keyframes pulsate-bck {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
    50% {
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
</style>
